import React from 'react';
import {
  string,
  func,
  shape,
  bool,
} from 'prop-types';
import Register from '../register/RegisterContainer';
import LogIn from '../login/LogInContainer';

class SignInSignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUniqueEmail: true,
    };

    this.updateIsUniqueEmail = this.updateIsUniqueEmail.bind(this);
  }

  updateIsUniqueEmail = (isUniqueEmail) => {
    this.setState({
      isUniqueEmail,
    });
  }

  render() {
    const {
      selectedTab,
      switchTab,
      forgotPasswordPath,
      customer,
      onSigninSuccess,
      onRegistrationSuccess,
      showSignIn,
      showSignUp,
      signInLabel,
      signUpLabel,
      signInLabelClassNameOverride,
      signUpLabelClassNameOverride,
      signInLabelDivClassNameOverride,
      signUpLabelDivClassNameOverride,
      showAlreadyHaveAccount,
      finishCreatingAccount,
      accountInvitationGuid,
      showAccountBenefitsText,
      showSignUpBorderBottom,
    } = this.props;

    let signInTab;
    if (showSignIn) {
      signInTab = (
        <React.Fragment>
          <input id="sign-in" type="radio" name="tabs" checked={selectedTab === 'signIn'} onChange={() => switchTab('signIn')} className="dn" />
          <label htmlFor="sign-in" className={signInLabelClassNameOverride || `title f6 f5-ns pointer bb b--light-gray dark-gray br3 br--top br--left ${showSignUp ? 'w-40' : 'w-100'} tc db`}>
            <div className={signInLabelDivClassNameOverride || 'center pv3 dib'} data-test-id="my-account-login-tab" id="sign-in-label-text">{signInLabel}</div>
          </label>
        </React.Fragment>
      );
    }

    let signUpTab;
    if (showSignUp) {
      const SignUpTitleElementType = this.props.signUpTitleElementType;
      const titleStyle = {};
      if (!showSignUpBorderBottom) {
        titleStyle.borderBottom = 'none';
      }

      signUpTab = (
        <React.Fragment>
          <input id="sign-up" type="radio" name="tabs" checked={selectedTab === 'signUp'} onChange={() => switchTab('signUp')} className="dn" />
          <label htmlFor="sign-up" className={signUpLabelClassNameOverride || `title flex f6 f5-ns pointer bb b--light-gray dark-gray br3 br--top br--right ${signInTab ? 'w-60' : 'w-100'} tc db`}>
            <SignUpTitleElementType
              className={signUpLabelDivClassNameOverride || 'center pv3 dib ph1'}
              data-test-id="my-account-register-tab"
              id="sign-up-label-text"
              style={titleStyle}
            >
              {signUpLabel}
            </SignUpTitleElementType>
          </label>
        </React.Fragment>
      );
    }

    return (
      <div className="gcc-tab h-100 items-start">
        {/* selectedTab(State) and switchTab(Function) should live in this component */}
        {signInTab}
        {signUpTab}
        <div className="gcc-tab-content w-100" id="sign-in-sign-up-content-wrapper">
          { /* should conditionally render the component based on selected tab */}
          {showSignIn && (
            <LogIn
              customer={customer}
              forgotPasswordPath={forgotPasswordPath}
              onSigninSuccess={onSigninSuccess}
            />
          )}
          {showSignUp && (
            <Register
              customer={customer}
              onRegistrationSuccess={onRegistrationSuccess}
              updateIsUniqueEmail={this.updateIsUniqueEmail}
              isUniqueEmail={this.state.isUniqueEmail}
              showAlreadyHaveAccount={showAlreadyHaveAccount}
              finishCreatingAccount={finishCreatingAccount}
              showSignIn={showSignIn}
              accountInvitationGuid={accountInvitationGuid}
              showAccountBenefitsText={showAccountBenefitsText}
            />
          )}
        </div>
      </div>
    );
  }
}

SignInSignUp.defaultProps = {
  customer: {},
  signInLabelClassNameOverride: undefined,
  signUpLabelClassNameOverride: undefined,
  signInLabelDivClassNameOverride: undefined,
  signUpLabelDivClassNameOverride: undefined,
  finishCreatingAccount: false,
  accountInvitationGuid: undefined,
  showAccountBenefitsText: true,
  showSignUpBorderBottom: true,
  signUpTitleElementType: 'div',
};

SignInSignUp.propTypes = {
  selectedTab: string.isRequired,
  switchTab: func.isRequired,
  forgotPasswordPath: string.isRequired,
  customer: shape({
    firstName: string,
    lastName: string,
    email: string,
  }),
  onSigninSuccess: func.isRequired,
  onRegistrationSuccess: func.isRequired,
  showSignIn: bool.isRequired,
  showSignUp: bool.isRequired,
  signInLabel: string.isRequired,
  signUpLabel: string.isRequired,
  signInLabelClassNameOverride: string,
  signUpLabelClassNameOverride: string,
  signInLabelDivClassNameOverride: string,
  signUpLabelDivClassNameOverride: string,
  showAlreadyHaveAccount: bool.isRequired,
  finishCreatingAccount: bool,
  accountInvitationGuid: string,
  showAccountBenefitsText: bool,
  showSignUpBorderBottom: bool,
  signUpTitleElementType: string,
};

export default SignInSignUp;
